var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApartmentinDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6269_24377",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6269_24377)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 17.5C3.70833 17.5 3.31597 17.3368 2.98958 17.0104C2.66319 16.684 2.5 16.2917 2.5 15.8333V7.5C2.5 7.04167 2.66319 6.64931 2.98958 6.32292C3.31597 5.99653 3.70833 5.83333 4.16667 5.83333H5.83333V4.16667C5.83333 3.70833 5.99653 3.31597 6.32292 2.98958C6.64931 2.66319 7.04167 2.5 7.5 2.5H12.5C12.9583 2.5 13.3507 2.66319 13.6771 2.98958C14.0035 3.31597 14.1667 3.70833 14.1667 4.16667V9.16667H15.8333C16.2917 9.16667 16.684 9.32986 17.0104 9.65625C17.3368 9.98264 17.5 10.375 17.5 10.8333V15.8333C17.5 16.2917 17.3368 16.684 17.0104 17.0104C16.684 17.3368 16.2917 17.5 15.8333 17.5H10.8333V14.1667H9.16667V17.5H4.16667ZM4.16667 15.8333H5.83333V14.1667H4.16667V15.8333ZM4.16667 12.5H5.83333V10.8333H4.16667V12.5ZM4.16667 9.16667H5.83333V7.5H4.16667V9.16667ZM7.5 12.5H9.16667V10.8333H7.5V12.5ZM7.5 9.16667H9.16667V7.5H7.5V9.16667ZM7.5 5.83333H9.16667V4.16667H7.5V5.83333ZM10.8333 12.5H12.5V10.8333H10.8333V12.5ZM10.8333 9.16667H12.5V7.5H10.8333V9.16667ZM10.8333 5.83333H12.5V4.16667H10.8333V5.83333ZM14.1667 15.8333H15.8333V14.1667H14.1667V15.8333ZM14.1667 12.5H15.8333V10.8333H14.1667V12.5Z",
    fill: "#837F39"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApartmentinDashboard);
export default __webpack_public_path__ + "static/media/apartmentinDashboard.711d38f1a6382faddb0675ab9805a38c.svg";
export { ForwardRef as ReactComponent };